import { DPUser } from './dp-user';

export class DPUsers {
  user: DPUser[];
}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-users.ts